import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  SxProps,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { CustomFieldSchemaFragment, Option } from "__generated__/graphql";
import { OptionChip } from "../option/OptionChip";
import { mapOptionChoiceToOption } from "customField/helpers/mapOptionChoiceToOption";

interface ICustomSelectProps {
  value: Option | null;
  setValue: (value: Option | null) => void;
  schema?: CustomFieldSchemaFragment | null;
  showLabel?: boolean;
  sx?: SxProps;
  labelledById?: string;
  errorMessage?: string;
  touched?: boolean;
}
export const CustomSelect: React.FC<ICustomSelectProps> = ({
  value,
  setValue,
  schema,
  showLabel,
  sx,
  labelledById,
  errorMessage,
  touched,
}) => {
  const { t: translateCustomField } = useTranslation("custom_field");
  const options = schema?.optionChoices
    ? schema.optionChoices.map(mapOptionChoiceToOption)
    : [];
  return (
    <FormControl
      aria-labelledby={labelledById || schema?.schemaId || ""}
      data-cy="custom-select"
      variant="outlined"
      size="small"
      fullWidth
      error={touched && errorMessage ? true : false}
    >
      {showLabel && (
        <InputLabel id={labelledById || schema?.schemaId || ""}>
          {schema?.name || ""}
        </InputLabel>
      )}
      <Select
        value={value?.value || ""}
        variant="outlined"
        data-cy={schema?.name.replace(" ", "-")}
        onChange={(e) => {
          const newOption = options.find(
            (option) => option.value === e.target.value,
          );
          setValue(newOption || null);
        }}
        label={showLabel && schema?.name}
        placeholder={schema?.name}
        sx={{ minWidth: 120, ...sx }}
      >
        <MenuItem value="" densedata-cy="none">
          {translateCustomField("forms.none")}
        </MenuItem>
        {options.map((option) => (
          <MenuItem
            value={option.value}
            dense
            key={option.value}
            data-cy={option.value}
          >
            <OptionChip
              data-custom-css-value={option.value} // for form custom css
              option={option}
            />
          </MenuItem>
        ))}
      </Select>
      {errorMessage && (
        <Typography color="error" variant="caption">
          {errorMessage}
        </Typography>
      )}
    </FormControl>
  );
};
